import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import Container from 'gatsby-theme-core/src/components/container';
import BackgroundImage from '../background-image';
import { CtaLink } from '../cta';

const PaulImage = ({ className }) => (
  <StaticImage
    className={className}
    src="../../images/paul2021.png"
    placeholder="none"
    layout="constrained"
    width={500}
    loading="eager"
    alt="Paul de Vries"
  />
);

const PdvHeader = () => (
  <Intro>
    <Container>
      <IntroBackgroundImage
        image="https://res.cloudinary.com/htkgpamks/image/upload/v1564139604/social-stain_ygn8w3.svg"
        position="center"
        size="contain"
      >
        <IntroInner>
          <article>
            <h1>Paul de Vries</h1>
            <RoundImage
              as={PaulImage}
            />
            <p>
              Founder of #DCDW and ambassador for
              Marktplaats Automotive & 2ehandsbe (Adevinta) -
              Making the online automotive better!
            </p>
            <IntroButton variant="primary" to="/over-mij">Lees mijn verhaal</IntroButton>
          </article>
          <IntroPaulImageWrapper>
            <StaticImage
              src="../../images/paul2021.png"
              placeholder="none"
              layout="fixed"
              width={500}
              loading="eager"
              alt="Paul de Vries"
            />
          </IntroPaulImageWrapper>
        </IntroInner>
      </IntroBackgroundImage>
    </Container>
  </Intro>
);

const Intro = styled.section`
  background-color: ${(props) => props.theme.secondaryColor};
  padding: 60px 0;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    padding: 60px 0 0 0;
  }
  article {
    color: white;
    max-width: 470px;
    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      padding-top: 30px;
    }
    h1 {
      margin: 0;
      padding-bottom: 30px;
      font-size:  2rem;
      font-family: ${(props) => props.theme.standoutFontFamily};
      color: inherit;
      text-transform: uppercase;
      @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
        font-size: 3.333rem;
      }
    }
    p {
      margin: 0;
      padding-bottom: 30px;
      font-size: 1.444rem;
      line-height: 150%;
    }
  }
`;

const IntroButton = styled(CtaLink)`
  display: block;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    display: inline-block;
  }
`;

const IntroBackgroundImage = styled(BackgroundImage)`
  background-size: 0px;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    background-position: center right;

    background-size: 50%;
  }
`;
const IntroInner = styled.div`
  display: flex;
  > article {
    width: 100%;
  }
`;
const IntroPaulImageWrapper = styled.div`
  flex-grow: 1;
  display: none;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    display: flex;
    height: auto;
    justify-content: flex-end;
    img {
      margin-left: auto;
    }
  }
`;

const RoundImage = styled.img`
  background-color: ${(props) => props.theme.secondaryDarkColor};
  background-color: #a3193a;
  border-radius: 50%;
  margin-bottom: 20px;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    display: none !important;
  }
`;

export default styled(PdvHeader)``;
